import { Link } from "react-router-dom";
import turnOff from "./../../../src/styles/assets/images/turnoff.svg";
import turnOffDark from "./../../../src/styles/assets/images/turnoffdark.svg";
import { Button } from "devextreme-react";
import { useAuth } from "react-oidc-context";
import { useSelector } from "react-redux";

export default ({ showPinBtn, redirect, site }) => {
  const { user, removeUser, signoutRedirect, clearStaleState } = useAuth();

  let isLightMode = useSelector((state) => state.theme.lightMode);

  const handleLogout = () => {
    removeUser();
    signoutRedirect({
      id_token_hint: user.id_token,
    });
    clearStaleState();
  };

  const navToHome = () => {
    if (redirect) {
      redirect();
    }
  };

  const pinTxt = site && site.isPinned ? "Unpin" : "Pin";

  return (
    <header>
      <Link onClick={navToHome} to="/">
        <div className="logo">
          <span className="site-logo"></span>
        </div>
      </Link>
      <div style={{ display: "flex" }}>
        {showPinBtn && (
          <button
            id="pinBtn"
            style={{ marginRight: "2rem" }}
            onClick={() => showPinBtn()}
            className="btn btn-primary"
          >
            <i className="icon icon-pinned"></i> {pinTxt} Site
          </button>
        )}

        <div className="dx-field">
          <div className="dx-field-value">
            <Button
              icon={isLightMode ? turnOffDark : turnOff}
              text="Log Out"
              onClick={handleLogout}
            />
          </div>
        </div>
      </div>
    </header>
  );
};
